import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from '@doccareplus/i18n';
import { selectIsAuthenticated, useAppSelector } from '@doccareplus/kernel/application';
import { PortalAuthLayout } from '../components/PortalAuthLayout';
import { PhoneOtpForm } from '../components/PhoneOtpForm';

// Patient portal login — passwordless phone + WhatsApp OTP. Separate page from register (clinic-style), linked
// via the footer. Distinct from clinic login: no email/password, no clinic-workspace picker.
export function PortalLoginPage() {
  const { t } = useTranslation('portal');
  const navigate = useNavigate();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  useEffect(() => {
    if (isAuthenticated) navigate('/', { replace: true });
  }, [isAuthenticated, navigate]);

  return (
    <PortalAuthLayout
      title={t('auth.loginTitle', 'Welcome back')}
      subtitle={t('auth.loginSubtitle', 'Log in with your phone number to continue.')}
      footer={
        <>
          {t('auth.noAccount', 'New to DocCare+?')}{' '}
          <Link to="/register" className="font-semibold text-[var(--primary)] hover:underline">
            {t('auth.createAccountLink', 'Create an account')}
          </Link>
        </>
      }
    >
      <PhoneOtpForm mode="login" />
    </PortalAuthLayout>
  );
}
